<template>
    <div id="files_main">
        <div v-if="files" class="files_entity" v-for="file in files">
            <file v-if="file.type === 'file'" :data="file"></file>
            <folder v-else :data="file" v-on:select="selectFolder($event)"></folder>
        </div>
    </div>
</template>

<script>
    import File from "./file";
    import Folder from "./folder";
    import Loader from "../miscellaneous/loader";
    export default {
        name: "files",
        components: {Loader, Folder, File},
        props: ['files', 'path'],
        data(){
            return {

            }
        },
        computed: {

        },
        methods: {
            selectFolder(name){
                this.$emit('selectFolder', name);
            }
        }
    }
</script>

<style scoped>
    #files_main{
        display: grid;
        grid-template-columns: repeat(auto-fill, 120px);
        grid-template-rows: repeat(auto-fill, 120px);
        grid-row-gap: .5em;
        grid-column-gap: 1em;
    }
    .files_entity{
        display: flex;
        height: 100%;
        width: 100%;
    }
    .files_entity:hover{
        background-color: var(--color-main-faded);
    }
</style>
